const data: string = "<div class=\"feeplan-section\"><h2 cms-html=\"feeplan-heading:apps/feeplan\"></h2><acp-feeplan></acp-feeplan></div>";
export default data